export default {"src":"/_next/static/media/fluxLogoPure.3024e2cd.svg","height":40,"width":35,"blurWidth":0,"blurHeight":0};